<template>
  <div class="deaths">
    <div v-if="loading">
      <v-progress-circular
        :size="20"
        color="primary"
        class="mr-2"
        indeterminate
      ></v-progress-circular>
      Loading..
    </div>

    <div v-else class="leaversTabs">
      <!--
      <v-tabs v-model="currentTab">
        <v-tab>Death</v-tab>
        <v-tab-item class="mt-4">
          <v-form
            ref="form"
            class="mb-4"
            v-model="isFormValid"
            lazy-validation
            :style="{ maxWidth: formMaxWidth + 'px' }"
          >
            <TabForm
              :formElements="formElements"
              :readOnly="!isEditMode"
              @max_column="calculateMaxFormWidth"
            />
          </v-form>
        </v-tab-item>

        <v-tab>Pension elements</v-tab>
        <v-tab-item class="mt-4">
          <PensionElements
            :pensionItems="pensionItems"
            :currentPlanId="currentPlanId"
            :selectedMemberId="selectedMemberId"
            :exitId="exitId"
            :isEditMode="isEditMode"
            @updatePensionElements="onUpdatePensionElements"
          />
        </v-tab-item>
      </v-tabs> 
      -->

      <v-form
            ref="form"
            class="mb-4"
            v-model="isFormValid"
            lazy-validation
            :style="{ maxWidth: formMaxWidth + 'px' }"
          >
            <TabForm
              :formElements="formElements"
              :readOnly="!isEditMode"
              @max_column="calculateMaxFormWidth"
              :planId="currentPlanId"
              :membershipId="selectedMemberId"
              :exitId="exitId"
              :elements="pensionItems"
              :defaultTabLabel="defaultTabLabel"
            />
          </v-form>

      <LeaversBtns
        :isDataExist="isDataExist"
        :isEditMode="isEditMode"
        :showFormButtons="showFormButtons"
        :showViewResults="calculatedValues.length > 0"
        :showQuoteButton="calculatedValues.length > 0"
        :isFormValid="isFormValid"
        @buttonClick="onButtonClick"
      />

      <v-dialog v-model="showCalculation" max-width="500" persistent>
        <Calculation
          formName="Deaths"
          :currentPlanId="currentPlanId"
          :selectedMemberId="selectedMemberId"
          @calculateClick="onCalculateClick"
        />
      </v-dialog>

      <v-dialog v-model="showCalculatedMessages" max-width="500" persistent>
        <CalculatedMessages
          :messages="calculatedMessages"
          @closeMessages="showCalculatedMessages = false"
        />
      </v-dialog>

      <v-dialog v-model="showCalculatedValues" max-width="500" persistent>
        <CalculatedValues :values="calculatedValues" @closeResults="showCalculatedValues = false" />
      </v-dialog>

      <v-dialog v-model="showQuote" max-width="700" persistent>
        <Letters
          @closeQuote="showQuote = false"
          :memberId="selectedMemberId"
          :calculationResults="calculationResults"
        />
      </v-dialog>
    </div>
    <Dialog ref="confirmationDialog"></Dialog>
  </div>
</template>

<script>
import TabForm from '@/components/TabForm.vue';
import Utils from '@/utils';
//import PensionElements from './PensionElements.vue';
import LeaversBtns from './LeaversBtns.vue';
import Calculation from './Calculation.vue';
import CalculatedMessages from './CalculatedMessages.vue';
import CalculatedValues from './CalculatedValues.vue';
import Letters from './Letters.vue';
import Dialog from '@/components/layout/Dialog.vue';

export default {
  name: 'Death',
  components: {
    TabForm,
    //PensionElements,
    LeaversBtns,
    Calculation,
    CalculatedMessages,
    CalculatedValues,
    Letters,
    Dialog,
  },
  props: {},

  data() {
    return {
      loading: false,
      formElements: [],
      isFormValid: false,
      exitData: [],
      isNewExitForm: false,
      isEditMode: false,
      selectedMemberDeaths: {},
      currentTab: 0,
      formMaxWidth: 500,
      showCalculation: false,
      calculatedValues: [],
      calculatedMessages: [],
      calculatedElements: [],
      showCalculatedMessages: false,
      showCalculatedValues: false,
      showQuote: false,
      calculationResults: [],
      pensionItemsCopy: [],
      defaultTabLabel: "Death",
    };
  },

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    selectedMemberId() {
      return this.$store.getters.selectedMemberId;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
    pensionItems() {
      if (Object.keys(this.selectedMemberDeaths).length) {
        return this.selectedMemberDeaths.PensionItems;
      }
      return [];
    },
    isNewForm() {
      if (this.selectedMemberId && !this.selectedMemberDeaths.ExitId) {
        return true;
      } else if (this.selectedMemberId && this.selectedMemberDeaths.ExitId) {
        return false;
      } else {
        return null;
      }
    },
    exitId() {
      return this.selectedMemberDeaths.ExitId;
    },
    isDataExist() {
      return Object.keys(this.selectedMemberDeaths).length > 1;
    },
  },

  watch: {
    selectedMemberId() {
      this.getDeathData();
    },
  },

  mounted() {
    if (!this.selectedMemberId) {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    } else {
      this.getForm();
      this.$root.currentPage = 'Leavers';
    }
  },

  destroyed() {
    this.$root.currentPage = null;
  },

  methods: {
    async onButtonClick(val) {
      if (val === 'cancel') {
        if (this.isNewForm) {
          this.formElements.forEach((el) => (el.Value = null));
          this.selectedMemberDeaths.PensionItems = [];
        } else {
          Utils.setDataToFormElements(this.selectedMemberDeaths, this.formElements);
          this.selectedMemberDeaths.PensionItems = JSON.parse(
            JSON.stringify(this.pensionItemsCopy)
          );
          this.calculatedElements.forEach((el) => {
            const index = this.selectedMemberDeaths.PensionItems.indexOf(el);
            this.selectedMemberExitData.splice(index, 1);
          });
        }

        this.isEditMode = false;
        this.calculatedMessages = [];
        this.calculatedElements = [];
        this.calculatedValues = [];
      } else if (val === 'save') {
        this.isFormValid = this.$refs.form.validate();
        if (this.isFormValid) {
          this.saveData();
        }
      } else if (val === 'delete') {
        try {
          await this.$refs.confirmationDialog.open(
            'Confirmation',
            'Are you sure you wish to delete this record?'
          );
          this.deleteData();
        } catch (err) {
          console.log();
        }
      } else if (val === 'edit') {
        this.isEditMode = true;
      } else if (val === 'calculate') {
        this.showCalculation = true;
        this.isEditMode = true;
      } else if (val === 'viewResults') {
        this.showCalculatedValues = true;
      } else if (val === 'quote') {
        this.showQuote = true;
      }
    },

    /*onUpdatePensionElements() {
      this.isFormValid = this.$refs.form.validate();
      if (this.isFormValid) this.saveData();
    },*/

    onCalculateClick(val, data) {
      if (val === 'cancel') {
        this.showCalculation = false;
      } else if (val === 'calculate') {
        this.showCalculation = false;
        if (data) {
          this.calculationResults = data;
          this.calculatedValues = data.Values || [];
          this.calculatedMessages = data.Messages || [];
          this.calculatedElements = data.Elements || [];

          if (this.calculatedMessages.length) {
            this.showCalculatedMessages = true;
          }

          if (data.Elements && data.Elements.length) {
            this.selectedMemberDeaths.PensionItems = [
              ...this.selectedMemberDeaths.PensionItems,
              ...data.Elements,
            ];
          }

          if (data.Values && data.Values.length) {
            data.Values.forEach((value) => {
              const updatingEl = this.formElements.find((el) => el.FieldName === value.FieldName);
              if (updatingEl) {
                updatingEl.Value = value.Value;
              }
            });
          }
        }
      }
    },

    calculateMaxFormWidth(maxColumnCount) {
      this.formMaxWidth = maxColumnCount * 400;
    },
    async getForm() {
      this.loading = true;
      try {
        const response = await this.$api.get(
          `/datadictionary/GetFormElements?formName=Deaths&planId=${this.currentPlanId}`
        );

        if (response.data.length) {
          response.data.sort((a, b) => a.FieldOrder - b.FieldOrder);
          this.formElements = response.data.filter((el) => el.Visible);
        }
        if (this.formElements.length) this.getDeathData();
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },

    async getDeathData() {
      this.loading = true;
      try {
        const response = await this.$api.get(
          '/death/GetExitDeathByMember?membershipId=' + this.selectedMemberId
        );

        if (response.data) {
          Utils.setDataToFormElements(response.data, this.formElements);
          this.selectedMemberDeaths = response.data;
          this.pensionItemsCopy = JSON.parse(
            JSON.stringify(this.selectedMemberDeaths.PensionItems)
          );
        } else {
          this.formElements.forEach((el) => (el.Value = ''));
          this.selectedMemberDeaths = { PensionItems: [] };
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },

    async saveData() {
      this.formElements.forEach((el) => {
        this.selectedMemberDeaths[el.FieldName] = el.Value;
      });
      this.selectedMemberDeaths.MembershipId = this.selectedMemberId;
      if (this.isNewForm) this.selectedMemberDeaths.ExitId = 0;
      this.loading = true;
      try {
        await this.$api.post('/death/UpdateExitDeath', this.selectedMemberDeaths);

        this.$store.commit('setNotificationMessage', { type: 'success', text: 'Data was saved' });
      } catch (error) {
        console.log(error.message);
      } finally {
        this.getDeathData();
        this.loading = false;
      }
    },

    async deleteData() {
      this.loading = true;
      try {
        await this.$api.delete('/death/DeleteExitDeath?Id=' + this.selectedMemberId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Data was deleted',
        });
      } catch (error) {
        console.log(error.message);
      } finally {
        this.getDeathData();
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.deaths {
  margin-bottom: 10px;
  padding-left: 30px;
  padding-right: 30px;

  .v-tabs {
    margin-bottom: 10px;

    .v-tabs-slider-wrapper {
      width: 0px !important;
      height: 0px !important;
    }

    .v-tab {
      border: 1px solid;
      border-radius: 30px;
      color: #4a1cd4 !important;
      height: 35px;
      margin-right: 10px;

      &.v-tab--active {
        color: white !important;
        background-color: #4a1cd4;
      }
    }
  }
}

.footerBtns {
  background-color: white;
  padding: 10px 20px;
}
</style>
